import React from 'react';
import { Button, Modal } from 'semantic-ui-react';
import { ColetaFluxo } from '../../types/coleta';
import { textoDaFila } from './coletaFluxoTexto';

export const ColetaAprovacaoAlerta: React.FC<{
  fluxo: ColetaFluxo;
  onAguardar: () => void;
  onEnviar: () => void;
}> = ({ fluxo, onAguardar, onEnviar }) => (
  <Modal open size="small" onClose={onAguardar}>
    <Modal.Header>Dados da qualidade ainda não foram processados</Modal.Header>
    <Modal.Content>
      <p>{textoDaFila(fluxo.fila) || 'Ainda não há dados da coleta para este CNPJ.'}</p>
      <p>Enviar o e-mail mesmo assim, sem esses dados, ou aguardar a coleta?</p>
    </Modal.Content>
    <Modal.Actions>
      <Button type="button" onClick={onAguardar}>Aguardar</Button>
      <Button type="button" primary onClick={onEnviar}>Enviar mesmo assim</Button>
    </Modal.Actions>
  </Modal>
);
